// extracted by mini-css-extract-plugin
module.exports = {"link":"BlogMetaInfo_link__H319Y","info":"BlogMetaInfo_info__AnNwu","readTime":"BlogMetaInfo_readTime__aafjV","label":"BlogMetaInfo_label__OuOHf"};